import React, { useContext, useEffect } from 'react';
import { LayoutContext } from '../../../contexts/layout.context';

import { useDispatch, useSelector } from 'react-redux';
import { getProgramsInfo } from '../../../store/thunks/programs';
import { authSelectors } from '../../../store/selectors/auth';
import { programsSelectors } from '../../../store/selectors/programs';
import { getUserInfoThunk } from '../../../store/thunks/profile';


import Plug from '../../../components/plug/plug.component';
import ProgramsBlock from '../../../components/Programs/Programs/ProgramsBlock/ProgramsBlock';
import TrialProgramsBlock from '../../../components/Programs/Programs/ProgramsBlock/TrialProgramsBlock';
import CoursesBlock from '../../../components/Programs/Programs/ProgramsBlock/CoursesBlock';
import TrialCoursesBlock from '../../../components/Programs/Programs/ProgramsBlock/TrialCoursesBlock';
import CertificateModalNew from '../../../components/Certificates/CertificateModalNew';
import usePreviewFeature from '../../../hooks/usePreviewFeature';
import Spinner from '../../../common/Spinner/Spinner';
import HeadTooltip from '../../../components/Tooltip/HeadTooltip';
import CourseTooltipHint from '../../../components/Tooltip/CourseTooltipHint';
import CertificateModal from '../../../components/Certificates/CertificateModal';
import { CertificatesProvider } from '../../../contexts/certificates.context';

const Programs = () => {
  const { setLayout } = useContext(LayoutContext);
  const dispatch = useDispatch();

  const auth = useSelector(authSelectors);
  const programs = useSelector(programsSelectors);
  const token = auth.token;
  const completedPrograms = programs.completedPrograms;
  const studyPrograms = programs.studyPrograms;

  const completedTrialPrograms = programs.completedTrialPrograms;
  const studyTrialPrograms = programs.studyTrialPrograms;
  const load = programs.load;
  const isRedesign = usePreviewFeature('courses-redesign');
  const StudyBlock = isRedesign ? CoursesBlock : ProgramsBlock;
  const TrialBlock = isRedesign ? TrialCoursesBlock : TrialProgramsBlock;

  useEffect(() => {
    document.title = 'Курси | New Brain';
    setLayout({ page: 'Курси' });
  }, [setLayout]);

  useEffect(() => {
    if (token) {
      dispatch(getProgramsInfo(token));
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      dispatch(getUserInfoThunk({ token }));
    }
  }, [token]);

  return (
    // Провайдер тут, а не в App: стан сертифікатів потрібен лише сторінці курсів,
    // а вантажити його при кожному вході в кабінет — зайвий запит.
    <CertificatesProvider>
      <section className="page programs container">
        <div className="program__tooltip">
          <HeadTooltip text={<CourseTooltipHint />} />
        </div>
        {load ? <Spinner /> : (
          (studyPrograms.length > 0 || completedPrograms.length > 0 || completedTrialPrograms.length > 0 || studyTrialPrograms.length > 0)
            ? (
              <div className="page-blocks">

                {studyTrialPrograms.length > 0 && (
                  <TrialBlock
                    title="Активні пробні"
                    courses={studyTrialPrograms}
                    initiallyOpen={true}
                  />
                )}

                {studyPrograms.length > 0 && (
                  <StudyBlock
                    title="В навчанні"
                    courses={studyPrograms}
                    initiallyOpen={true}
                  />
                )}

                {completedPrograms.length > 0 && (
                  <StudyBlock
                    title={`Завершені (${completedPrograms.length})`}
                    courses={completedPrograms}
                    initiallyOpen={false}
                  />
                )}

                {completedTrialPrograms.length > 0 && (
                  <TrialBlock
                    title={`Завершені пробні (${completedTrialPrograms.length})`}
                    courses={completedTrialPrograms}
                    initiallyOpen={false}
                  />
                )}

              </div>
            )
            : <Plug plug="Дані про курси відсутні!" icon="icon-closed" />
        )}

        {isRedesign ? <CertificateModalNew /> : <CertificateModal />}
      </section>
    </CertificatesProvider>
  );
};

export default Programs;